import React, { useContext, useMemo } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import CmsContext from 'context/CmsContext';
import LeafletMap from 'modules/common/components/LeafletMap';

function BusinessAddress({ data }) {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const defaultLat = +get(CMS_COMPONENTS, 'BPLS_PINNED_LOCATION_LATITUDE', 0);
  const defaultLng = +get(CMS_COMPONENTS, 'BPLS_PINNED_LOCATION_LONGITUDE', 0);
  const pinnedLocation = get(data, 'attributes.pinned_geolocation', '');

  const selectedCoords = useMemo(() => {
    const defaultCoords = {
      lat: defaultLat,
      lng: defaultLng,
    };

    if (!pinnedLocation) return defaultCoords;

    const [lat, lng] = pinnedLocation.split(',');
    return {
      lat: +lat,
      lng: +lng,
    };
  }, [pinnedLocation]);

  return (
    <div className="p-3">
      <table className="transaction-table table table-borderless table-sm">
        <tbody>
          <tr className="d-flex">
            <td>
              <span className="title" style={{ fontSize: '16px' }}>
                BUSINESS ADDRESS
              </span>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="350">
              Business Address
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>
                {get(
                  data,
                  'attributes.main_office_display_address'
                ) || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="350">
              Location Owned
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>
                {get(
                  data,
                  'attributes.location_owned'
                ) ? 'YES' : 'NO' || '-'}
              </b>
            </td>
          </tr>
          {get(data, 'attributes.location_owned') ? (
            <tr>
              <td className="text-dark" width="350">
                Tax Declaration No. or Property Identification No.
              </td>
              <td className="text-dark" width="1">
                :
              </td>
              <td colSpan={4}>
                <b>
                  {get(data, 'attributes.pin_no') ||
                    get(data, 'attributes.tdn_no')}
                </b>
              </td>
            </tr>
          ) : (
            <>
              <tr>
                <td className="text-dark" width="350">
                  Lessor Name
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>
                    {get(data, "attributes.lessor_name") || "--"}
                  </b>
                </td>
              </tr>
              <tr>
                <td className="text-dark" width="350">
                  Monthly Rental
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>
                    {get(data, "attributes.monthly_rental") || "--"}
                  </b>
                </td>
              </tr>
            </>
          )}          
        </tbody>
      </table>

      <hr className="ct-hr" />
      <div
        style={{ height: '500px', width: '100%' }}
        className="mt-3 d-flex flex-column"
      >
        <LeafletMap
          pins={[selectedCoords]}
          zoom={19}
          center={[selectedCoords.lat, selectedCoords.lng]}
          viewOnly
        />
      </div>
    </div>
  );
}

BusinessAddress.defaultProps = {
  data: {},
};

BusinessAddress.propTypes = {
  data: PropTypes.instanceOf(Object),
};

export default BusinessAddress;
